// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:Evd5vQ */\n.gCMEJ{align-items:center;display:flex;flex-direction:column;position:relative;width:100%}._5shPn{bottom:0;font-size:var(--audio-font-size-15);font-weight:400;left:0;line-height:var(--audio-line-height-20);position:absolute;right:0;text-align:center}.ii2cD{align-items:center;display:flex;gap:var(--audio-spacing-24);width:100%}._6ynfP{flex:1;height:94px;min-width:0;position:relative}._6ynfP > :first-child{height:100%}.waQE4{bottom:0;display:none;left:0;pointer-events:none;position:absolute;right:0;top:0}.waQE4 > *{height:100%}.waQE4 a{pointer-events:auto}.PZRBu{display:none}@media (min-width:1280px){._6ynfP{height:120px}._5shPn{bottom:auto;left:auto;right:0;text-align:right;top:0}.PZRBu{display:flex}.waQE4{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"playback": "gCMEJ",
	"time": "_5shPn",
	"row": "ii2cD",
	"waveform": "_6ynfP",
	"overlay": "waQE4",
	"sidePlay": "PZRBu"
};
export default ___CSS_LOADER_EXPORT___;
